import {
  AuthenticatedUserSerializedType,
  BasicUserSerializedType,
} from 'sweet-types';

export const user_data_fixture: AuthenticatedUserSerializedType = {
  id: 0,
  name: 'Guest',
  content_type: 'user',
  emailstatus: null,
  is_deleted: false,
  timezone: 'America/Sao_Paulo',
  language: 'en',
  language_label: 'english',
  num_accounts: 1,
  is_staff: false,
  is_manager: true,
  is_super_manager: true,
  is_email_verified: true,
  emoji_skin_tone: '',
  avatar_image: null,
  is_super_teammate: false,
  notifications_modified_at: null,
  num_notifications: 0,
  tours: {
    edit: {
      status: 'finished',
      version: 0,
    },
    dashboard: {
      status: 'finished',
      version: 0,
    },
    view: {
      status: 'finished',
      version: 0,
    },
    assign_steps: {
      status: 'finished',
      version: 0,
    },
  },
  team_memberships: [],
  teams: [],
  html_url: '/people/user/0/',
  url: '/api/v1/users/0/',
  is_diagrams_expanded: true,
  is_guest_until: null,
  post_login_redirect: 'home',
  navigation_links:
    'documents,procedures,processes,tasks,policies,teams,members,tags,kbase,templates',
  email: 'guest@example.com',
  emailaddresses: [],
  can_assign_tasks: true,
  is_two_factor: false,
  is_owner: false,
  is_billing_admin: true,
  restrict_saml_only_login: false,
};

function createBasicUserFromUser({
  id,
  url,
  name,
  email,
  avatar_image,
  is_deleted,
}: AuthenticatedUserSerializedType): BasicUserSerializedType {
  return {id, url, name, email, content_type: 'user', avatar_image, is_deleted};
}

export const basic_user_data_fixture =
  createBasicUserFromUser(user_data_fixture);

export const basic_account_owner_user_data_fixture: BasicUserSerializedType = {
  id: 4,
  url: '/api/v1/users/4/',
  name: 'Account Owner',
  email: 'new-account@example.com',
  content_type: 'user',
  avatar_image: null,
  is_deleted: false,
};
